/**
 * Einstiegspunkt der Monteur-PWA — `PWA-001`.
 *
 * Wie im Portal lebt das Framework hier und nur hier. ADR-016 hält die
 * Grenze: `packages/contracts`, `packages/domain/**` und `packages/sync`
 * bleiben frei von React, HTTP und Node-APIs — damit die native App aus
 * `02` §2.13 offen bleibt und ein Wechsel den Einstiegspunkt kostet und nicht
 * die Anwendung.
 *
 * **Noch keine PWA im engeren Sinn.** Manifest, Service Worker und
 * Installierbarkeit gehören zu `PWA-001` und brauchen eine gesicherte
 * Herkunft; der verschlüsselte Offlinecache aus `05` §5.6 gehört zu
 * `PWA-003`. Was hier läuft, ist die Anwendung darin — Ablauf, Erfassung und
 * Offline-UX —, und die lässt sich ohne beides beurteilen.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import { setzeAustauschadresse } from "@hwc/demo-data";

import { App } from "./App.js";

import "@hwc/ui/bauteile.css";
import "./stil.css";

/**
 * Wo der Austauschdienst liegt.
 *
 * Er läuft im Entwicklungsserver des Portals — die App hat keinen eigenen und
 * soll auch keinen bekommen: Zwei Dienste wären zwei Stände, und dann prüft
 * man gegen den falschen.
 *
 * Die Vorgabe ist Port 4300. Weicht `pnpm demo` darauf aus, weil der Port
 * belegt ist, nennt man die richtige Adresse im Suchparameter:
 * `?austausch=http://localhost:4301/demo-austausch`. Umständlich, aber
 * ehrlich — die Alternative wäre Raten, und eine App, die stillschweigend den
 * falschen Dienst befragt, ist schlimmer als eine, die keinen findet.
 */
const gewaehlt = new URLSearchParams(window.location.search).get("austausch");
if (gewaehlt) setzeAustauschadresse(gewaehlt);

const wurzel = document.getElementById("wurzel");
if (!wurzel) throw new Error("Kein Element #wurzel in index.html");

createRoot(wurzel).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
